<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card
          titleIcon="FilterIcon"
          ref="filterCard"
          title="Advanced Filters"
          class="user-list-filters mb-8"
          :collapse-action="true"
        >
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Code</label>
              <vs-input
                type="text"
                class="w-full"
                placeholder="Search"
                v-model="filters['code']"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">From</label>
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y' }"
                v-model="filters['from']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">To</label>
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y' }"
                v-model="filters['to']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">status</label>
              <v-select
                :options="statusOptions"
                v-model="filters['status']"
                :reduce="(option) => option.value"
                label="label"
                placeholder="Select status"
                :clearable="false"
                class="w-full vs-select-lg"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full md:w-6/6">
              <div class="btn-group float-right">
                <vs-button
                  class="float-right mr-4"
                  size="small"
                  color="danger"
                  type="border"
                  icon-pack="feather"
                  v-on:click="filters = {}"
                  >CLEAR</vs-button
                >
              </div>
            </div>
          </div>
        </vx-card>
        <vx-card title="Triangle Test List">
          <template slot="actions">
            <vs-button
              class="mr-4"
              @click="onCLickCreateTest"
              color="primary"
              type="filled"
              v-can="'create-edit-quality-control-tastings'"
              >Create</vs-button
            >
          </template>
          <vs-table
            :max-items="meta.per_page ? meta.per_page : 10"
            stripe
            :data="testList"
            :sst="true"
            class="table-dark-inverted table-auto vs-con-loading__container"
            id="mass-balance-audit-table"
            @sort="handleSort"
          >
            <template slot="thead">
              <vs-th>CODE</vs-th>
              <vs-th>DONE BY</vs-th>
              <vs-th>STATUS</vs-th>
              <vs-th>CREATED AT</vs-th>
              <vs-th>ACTIONS</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="(tr, indextr) in data" :key="indextr">
                <vs-td>
                  {{ tr.code }}
                </vs-td>

                <vs-td>
                  {{ tr.done_by.name }}
                </vs-td>

                <vs-td>
                  {{ tr.status }}
                </vs-td>

                <vs-td>
                  {{ __dateTimeFormatterToDate(tr.created_at) }}
                </vs-td>

                <vs-td>
                  <div class="vx-row">
                    <vx-tooltip
                      class="text-primary cursor-pointer"
                      text="View"
                      position="left"
                    >
                      <vs-button
                        @click.stop="onClickViewTest(tr.id)"
                        v-can:any="[
                          'view-quality-control-tastings',
                          'create-edit-quality-control-tastings',
                        ]"
                        size="small"
                        icon-pack="feather"
                        icon="icon-eye"
                      ></vs-button>
                    </vx-tooltip>
                    <vx-tooltip
                      class="text-primary cursor-pointer ml-1"
                      text="Update status"
                      position="left"
                    >
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-pagination
            v-on:changeMaxItems="changePage"
            :size-array="meta.total ? meta.total : 20"
            :max-items="perPage"
            description-body="Rows per page"
            description-connector="of"
            description-title="Records"
            description
            :description-items="descriptionItems"
            :total="meta.last_page ? meta.last_page : 0"
            v-model="page"
            class="p-5"
          >
          </vs-pagination>
        </vx-card>
      </div>
      <TriangleTestCreate ref="triangleTestCreate" @refresh="refresh" />
    </div>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import ErrorMessages from "@/mixins/ErrorMessages";
import Filter from "@/mixins/filter";
import TriangleTestCreate from "@/components/popups/TastePanel/TriangleTestCreate.vue";

const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");

export default {
  name: "FormTests",
  data() {
    return {
      meta: {},
      maxItems: 20,
      page: 1,
      total: 0,
      sort: "",
      perPage: defaultPagination,
      descriptionItems: perPageList,
      filters: {},
      testList: [],
      statusOptions: [],
    };
  },
  components: {
    flatPickr,
    "v-select": vSelect,
    TriangleTestCreate,
  },
  mixins: [ErrorMessages, Filter],
  async mounted() {
    await this.getTestList();
    await this.fetchStatusList();
  },
  methods: {
    refresh() {
      this.getTestList();
    },
    async getTestList() {
      try {
        this.$vs.loading();
        const response = await TriangleTestsRepository.getTriangleTestList(
          this.filterQuery,
          this.page,
          this.perPage
        );
        this.testList = response.data.data;
        this.meta = response.data.meta;
      } catch (e) {
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchStatusList() {
      try {
        const response =
          await TriangleTestsRepository.getTriangleTestStatusList();
        this.statusOptions = response.data.data;
      } catch (e) {}
    },

    onCLickCreateTest() {
      this.$refs.triangleTestCreate.openPopup();
    },
    onClickViewTest(id) {
      this.$refs.triangleTestCreate.openPopup(id);
    },
    filterQueryUpdate() {
      this.getTestList();
    },
    handleChangePage(page) {
      this.page = page;
      this.getTestList();
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index];
    },
  },
};
</script>
